import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@upme/ui/components/alert-dialog';
import { Button } from '@upme/ui/components/button';
import { toast } from 'sonner';
import { FakeForm } from '../../../../features/users/components/fake-form';
import { FakePhotoUploader } from '../../../../features/users/components/fake-photo-uploader';
import { useDeleteFake, useUpdateFake } from '../../../../features/users/mutations';
import { fakeByIdOptions } from '../../../../features/users/queries';
import { PageHeader } from '../../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/users/fakes/$fakeId')({
  loader: ({ context, params }) => context.queryClient.ensureQueryData(fakeByIdOptions(params.fakeId)),
  component: EditFakePage,
});

function EditFakePage() {
  const { fakeId } = Route.useParams();
  const navigate = useNavigate();
  const { data } = useSuspenseQuery(fakeByIdOptions(fakeId));
  const update = useUpdateFake(fakeId);
  const del = useDeleteFake();

  return (
    <div className="space-y-8">
      <PageHeader title={[data.firstName, data.lastName].filter(Boolean).join(' ') || '—'} />

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Аватар</h2>
        <FakePhotoUploader userId={fakeId} photoUrl={data.photoUrl} />
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Профиль</h2>
        <FakeForm
          submitLabel="Сохранить"
          initialValues={{
            firstName: data.firstName ?? '',
            lastName: data.lastName ?? undefined,
            cityId: data.cityId ?? '',
            bio: data.bio ?? undefined,
            interests: data.interests,
            isDiscoverable: data.isDiscoverable,
          }}
          onSubmit={async (values) => {
            try {
              await update.mutateAsync(values);
              toast.success('Сохранено');
            } catch (err) {
              toast.error((err as Error).message);
            }
          }}
        />
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Опасная зона</h2>
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button variant="destructive">Удалить фейк</Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Удалить фейк?</AlertDialogTitle>
              <AlertDialogDescription>
                Будут удалены профиль, свайпы и матчи этого юзера. Действие необратимо.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Отмена</AlertDialogCancel>
              <AlertDialogAction
                onClick={async () => {
                  try {
                    await del.mutateAsync(fakeId);
                    toast.success('Удалён');
                    navigate({ to: '/users/fakes' });
                  } catch (err) {
                    toast.error((err as Error).message);
                  }
                }}
              >
                Удалить
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </section>
    </div>
  );
}
